import { render, staticRenderFns } from "./ProStatisticsBPage.vue?vue&type=template&id=6f2e17a6"
import script from "./ProStatisticsBPage.vue?vue&type=script&lang=js"
export * from "./ProStatisticsBPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports